import { useState } from 'react';
import Card from 'src/components/Card';
import Search from 'src/components/Search';
import SelectField from 'src/components/SelectField';

import { AdminSchool } from './adminSetup.types';
import { useSchoolsQuery } from './adminSetupApi';
import ParaPlacementsTable from './ParaPlacementsTable';
import PlacementForm from './PlacementForm';
import ProviderForm from './ProviderForm';
import SchoolSignerForm from './SchoolSignerForm';
import StudentForm from './StudentForm';

type Picked = { id: string; label: string };

const AdminSetup = () => {
  const [provider, setProvider] = useState<Picked>();
  const [student, setStudent] = useState<Picked>();
  const [schoolSearch, setSchoolSearch] = useState('');
  const [schoolId, setSchoolId] = useState<string>();
  const [placementsVersion, setPlacementsVersion] = useState(0);

  const { data: schools, isFetching: schoolsLoading } = useSchoolsQuery({ search: schoolSearch });
  const school: AdminSchool | undefined = schools?.find((s) => s.id === schoolId);

  return (
    <div className="flex flex-col gap-6 bg-neutral-950 p-10">
      <div>
        <div className="mb-2 text-neutral-100 typography-heading-xl">Para setup</div>
        <div className="text-neutral-300 typography-body-lg">
          Create a Para provider, a student, a school signer, and the placement. No CRM involved.
        </div>
      </div>

      <Card title="1. Provider (creates portal login)">
        <ProviderForm onCreated={(id, label) => setProvider({ id, label })} />
      </Card>

      <Card title="2. Student">
        <StudentForm onCreated={(id, label) => setStudent({ id, label })} />
      </Card>

      <Card title="3. School and principal signer">
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <Search
              size="md"
              value={schoolSearch}
              onChange={(e) => setSchoolSearch(e.target.value)}
              className="h-12 w-full rounded-lg border-0 bg-neutral-white shadow-elevation-1"
            />
            <SelectField
              label="School"
              placeholder={schoolsLoading ? 'Loading…' : 'Pick a school'}
              value={schoolId}
              onValueChange={setSchoolId}
              options={(schools ?? []).map((s) => ({ label: s.name, value: s.id }))}
            />
          </div>
          {school && <SchoolSignerForm school={school} />}
        </div>
      </Card>

      <Card title="4. Para placement">
        <div className="mb-4 text-neutral-300 typography-body-sm">
          Newly created records are pre-selected. Change any picker to reuse an existing provider,
          student or school. Records created on this page are marked &quot;portal&quot;.
        </div>
        <PlacementForm
          providerId={provider?.id}
          studentId={student?.id}
          schoolId={school?.id}
          onCreated={() => setPlacementsVersion((v) => v + 1)}
        />
      </Card>

      <Card title="Para placements">
        <ParaPlacementsTable key={placementsVersion} />
      </Card>
    </div>
  );
};

export default AdminSetup;
